import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Autoplay]);

// Export for global use if needed
window.Swiper = Swiper

// AOS
import 'aos/dist/aos.css';
import AOS from 'aos';
AOS.init()

// Lazyload
import lazyLoadInit from '../../../../general/js/lazy';
lazyLoadInit();

// fslightbox
import FsLightbox from "fslightbox";

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

const setupApp = ()=>
{
    refreshFsLightbox();

    const StoreSwiper = new Swiper(".StoreSwiper", {
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        breakpoints: {
            360: {
                slidesPerView: 2,
                loop: true,
            },
            520: {
                slidesPerView: 2,
                loop: true,
            },
            768: {
                slidesPerView: 2.5,
                loop: true,
            },
            1024: {
                slidesPerView: 3.5,
                loop: true,
            }
            ,
            1280: {
                slidesPerView: 4,
                loop: true,
            },
            1600: {
                slidesPerView: 4,
                loop: true,
            },
            1920: {
                slidesPerView: 4,
                loop: true,
            },
        },
        loop: true,

        autoplay: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        navigation: {
            nextEl: ".store-button-next",
            prevEl: ".stroe-button-prev",
        },
    });

    const nextShopSlideButton = document.querySelectorAll('.shop-next-slide');
    const prevShopSlideButton = document.querySelectorAll('.shop-prev-slide');

    nextShopSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            StoreSwiper.slideNext();
        });
    });
    prevShopSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            StoreSwiper.slidePrev();
        });
    });

    const AcademySwiper = new Swiper(".AcademySwiper", {
        autoplay: true,

        breakpoints: {
            360: {
                slidesPerView: 1.1,
                loop: true,
            },
            520: {
                slidesPerView: 2,
                loop: true,
            },
            768: {
                slidesPerView: 2.5,
                loop: true,
            },
            1024: {
                slidesPerView: 3.5,
                loop: true,
            }
            ,
            1280: {
                slidesPerView: 4,
                loop: true,
            },
            1600: {
                slidesPerView: 4,
                loop: true,
            },
            1920: {
                slidesPerView: 4,
                loop: true,
            },
        },

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        navigation: {
            nextEl: ".academy-button-next",
            prevEl: ".academy-button-prev",
        },
    });


    const nextAcademySlideButton = document.querySelectorAll('.academy-next-slide');
    const prevAcademySlideButton = document.querySelectorAll('.academy-prev-slide');

    nextAcademySlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            AcademySwiper.slideNext();
        });
    });
    prevAcademySlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            AcademySwiper.slidePrev();
        });
    });

    const BlogSwiper = new Swiper(".BlogSwiper", {
        autoplay: true,
        breakpoints: {
            320: {
                slidesPerView: 1.3,
                loop: true,
            },
            520: {
                slidesPerView: 2,
                loop: true,
            },
            768: {
                slidesPerView: 3,
                loop: true,
            }
            ,
            1280: {
                slidesPerView: 3,
                loop: false,
            },
            1920: {
                slidesPerView: 3,
                loop: false,
            },
        }
    });

};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})
